/* eslint-disable @typescript-eslint/no-explicit-any */
import debug from 'debug';
/**
 * Create Debug instances
 * @public
 */
export class Debug {
    /** Creates a debugger function using the namespace `io:${namespace}` */
    static create(namespace) {
        return Debug.instance.extend(namespace);
    }
}
Debug.instance = debug('io');
//# sourceMappingURL=debug.js.map